import * as React from "react";

const SvgCheckboxEmpty = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.2 3H14.8C16.015 3 17 3.98497 17 5.2V14.8C17 16.015 16.015 17 14.8 17H5.2C3.98497 17 3 16.015 3 14.8V5.2C3 3.98497 3.98497 3 5.2 3Z" stroke="#34B3E1" strokeWidth={2} /></svg>;

export default SvgCheckboxEmpty;